/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PhoneInput/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ChoiceRadial from 'DesignSystem/ChoiceRadial/index'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import UsePatientValue from './UsePatientValue/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function PhoneInput({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/PhoneInput",
  onChange,
  disabled
  
}) {
let phoneDetailsPhoneNumberValueData = fromData.useDataValue({ viewPath,
context: 'phoneDetails',
path: 'phoneNumber',
})
let phoneDetailsPhoneNumberChangeData = fromData.useDataChange({ viewPath,
context: 'phoneDetails',
path: 'phoneNumber',
})
let questionIsValidValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'isValid',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onKeyUp = fromHelpers.useOnKeyUp({
  children,
  viewPath,
  onChange,
  disabled
  
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let phoneDetailsPhoneTypeValueData = fromData.useDataValue({ viewPath,
context: 'phoneDetails',
path: 'phoneType',
})
let constantData = 'CELL'
let aggregateData = fromAggregate.equals(phoneDetailsPhoneTypeValueData, constantData)
let phoneDetailsPhoneTypeChangeData = fromData.useDataChange({ viewPath,
context: 'phoneDetails',
path: 'phoneType',
})
let dtChoiceradialStrokeBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.stroke.brand.base'
        })
let dtChoiceradialBordercolorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.borderColor.brand.base'
        })
let dtChoiceradialBackgroundcolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.backgroundColor.brand.selected'
        })
let dtChoiceradialBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.borderColor.brand.hovered'
        })
let dtChoiceradialColorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.color.brand.hovered'
        })
let dtChoiceradialColorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.color.brand.selected'
        })
let dtChoiceradialBackgroundcolorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ChoiceRadial.backgroundColor.brand.base'
        })
let phoneDetailsPhoneTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'phoneDetails',
path: 'phoneType',
})
let constantData1 = 'LANDLINE'
let aggregateData1 = fromAggregate.equals(phoneDetailsPhoneTypeValueData1, constantData1)
let phoneDetailsPhoneTypeChangeData1 = fromData.useDataChange({ viewPath,
context: 'phoneDetails',
path: 'phoneType',
})
let dtCheckboxStrokeBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.stroke.brand.selected'
        })
let dtCheckboxBackgroundcolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.backgroundColor.brand.selected'
        })
let dtCheckboxBordercolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.borderColor.brand.selected'
        })
let dtCheckboxBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.borderColor.brand.hovered'
        })
let phoneDetailsAllowNotificationsValueData = fromData.useDataValue({ viewPath,
context: 'phoneDetails',
path: 'allowNotifications',
})
let phoneDetailsAllowNotificationsChangeData = fromData.useDataChange({ viewPath,
context: 'phoneDetails',
path: 'allowNotifications',
})
let phoneDetailsAllowConsentValueData = fromData.useDataValue({ viewPath,
context: 'phoneDetails',
path: 'allowConsent',
})
let phoneDetailsAllowConsentChangeData = fromData.useDataChange({ viewPath,
context: 'phoneDetails',
path: 'allowConsent',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let widgetSettingsPhoneoptinValueData = fromData.useDataFormat({ viewPath,
context: 'widget',
path: 'settings.phoneOptin',
format: fromHelpers.optinText,
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 width={250}
 marginTop={0}
 flexGrow={0}
 paddingLeft={0}
 paddingTop={dtSpaceXs}
 backgroundColor="transparent"
 data="phoneDetails.phoneNumber"
 onChange={phoneDetailsPhoneNumberChangeData}
 value={phoneDetailsPhoneNumberValueData}
 data="question.isValid"
 invalid={!questionIsValidValueData}
 disabled={disabled}
 type="text"
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 paddingLeft={dtSpaceXs}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="phone"
 placeholder="(000) 000-0000"
 autoFocus={true}
 onKeyUp={onKeyUp}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
<div
  data-testid="PhoneInput.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-aKCOc': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<ChoiceRadial
  viewPath={`${viewPath}/ChoiceRadial`}
 id="CELL"
 width={110}
 data="phoneDetails.phoneType"
 data="'CELL'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 data="phoneDetails.phoneType"
 onClick={phoneDetailsPhoneTypeChangeData}
 stroke={dtChoiceradialStrokeBrandBase}
 borderColor={dtChoiceradialBordercolorBrandBase}
 backgroundColorSelected={dtChoiceradialBackgroundcolorBrandSelected}
 borderColorHovered={dtChoiceradialBordercolorBrandHovered}
 colorHovered={dtChoiceradialColorBrandHovered}
 colorSelected={dtChoiceradialColorBrandSelected}
 backgroundColor={dtChoiceradialBackgroundcolorBrandBase}
 isDisabled={disabled}
 text="Cell"
/>
<ChoiceRadial
  viewPath={`${viewPath}/ChoiceRadial`}
 id="LANDLINE"
 width={110}
 marginLeft={dtSpaceXs}
 data="phoneDetails.phoneType"
 data="'LANDLINE'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
 data="phoneDetails.phoneType"
 onClick={phoneDetailsPhoneTypeChangeData1}
 isDisabled={disabled}
 stroke={dtChoiceradialStrokeBrandBase}
 backgroundColorSelected={dtChoiceradialBackgroundcolorBrandSelected}
 borderColorHovered={dtChoiceradialBordercolorBrandHovered}
 colorHovered={dtChoiceradialColorBrandHovered}
 colorSelected={dtChoiceradialColorBrandSelected}
 text="Landline"
/>
</div>
<UsePatientValue
  viewPath={`${viewPath}/UsePatientValue`}
 strokeSelected={dtCheckboxStrokeBrandSelected}
 backgroundColorSelected={dtCheckboxBackgroundcolorBrandSelected}
 borderColorSelected={dtCheckboxBordercolorBrandSelected}
 borderColorHovered={dtCheckboxBordercolorBrandHovered}
/>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginTop={dtSpaceS}
 data="phoneDetails.allowNotifications"
 value={phoneDetailsAllowNotificationsValueData}
 onChange={phoneDetailsAllowNotificationsChangeData}
 strokeSelected={dtCheckboxStrokeBrandSelected}
 backgroundColorSelected={dtCheckboxBackgroundcolorBrandSelected}
 borderColorSelected={dtCheckboxBordercolorBrandSelected}
 borderColorHovered={dtCheckboxBordercolorBrandHovered}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Yes, send me appointment reminders"
/>
</React.Fragment>
)}
</TysiaCheckbox>
<div
  data-testid="PhoneInput.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginTop={dtSpaceM}
 data="phoneDetails.allowConsent"
 value={phoneDetailsAllowConsentValueData}
 onChange={phoneDetailsAllowConsentChangeData}
 strokeSelected={dtCheckboxStrokeBrandSelected}
 backgroundColorSelected={dtCheckboxBackgroundcolorBrandSelected}
 borderColorSelected={dtCheckboxBordercolorBrandSelected}
 borderColorHovered={dtCheckboxBordercolorBrandHovered}
>
{childProps => (
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
)}
</TysiaCheckbox>
<div
  data-testid="PhoneInput.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-aKCOc': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--ml-2-aKCOc': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color="#666"
 data="widget.settings.phoneOptin"
 format="helpers.js optinText"
 text={widgetSettingsPhoneoptinValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color="#666"
 text="Message and data rates may apply. Message frequency varies. Reply STOP to opt-out."
/>
</div>
</div>
{children}
</React.Fragment>)
}